import { useEffect, useState } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Grid,
  TextField,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useQuery } from "@apollo/client";
//Srcs
import "../Style/pagestyle.scss";
import FooterPagination from "../Components/Include/FooterPagination";
import LoadingPage from "../Components/Include/LoadingPage";
import EmptyData from "../Components/Include/EmptyData";
import {
  GET_INVENTORY_PLAN_PAGINATION,
} from "../Schema/InventoryPlan";
import CreateIcon from "../Assets/create-icon.svg";
import {
  SelectAcademicYear,
} from "../Components/Include/DynamicSelect";
import InventoryPlanForm from "../Components/InventoryPlan/InventoryPlanForm";
import InventoryPlanAction from "../Components/InventoryPlan/InventoryPlanAction";
// 
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { parseISO } from "date-fns";
import moment from "moment";


export default function InventoryPlan() {
  // 
  const [loading, setLoading] = useState(true); 
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  const [academicVal, setAcademicVal] = useState({ id: "", title: "" });
  const [date,setDate] = useState("");
  const [planFor,setPlanFor] = useState("all");

  // 
  const [openCreate, setOpenCreate] = useState(false);
  const handleOpenCreate = () => setOpenCreate(true);
  const handleCloseCreate = () => setOpenCreate(false);

  // 
  const { refetch } = useQuery(GET_INVENTORY_PLAN_PAGINATION, {
    variables: {
      page,
      limit,
      pagination: true,
      academicYearId: academicVal?.id || "",
      planFor: planFor === 'all' ? null : planFor,
      date: date || "",
    },
    onCompleted: ({ getInventoryPlanPagination }) => {
      setTableData(getInventoryPlanPagination?.data);
      setPaginationData(getInventoryPlanPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      setLoading(true);
      console.log("Error::", err?.message);
    },
    pollInterval: 1000,
  });

  useEffect(() => {
    refetch();
    setLoading(true);
  }, [
    academicVal?.id,
    page,
    limit,
  ]);

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => setWidth(window.innerWidth - 50);

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);


  return (
    <div className="page-container">

      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">ផែនការ</Typography>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className="header-text">ជ្រើសរើសឆ្នាំសិក្សា</Typography>
            <SelectAcademicYear
              className="search-field"
              selectedVal={academicVal}
              setSelectedVal={setAcademicVal}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className="header-text">ជ្រើសរើសផែនការ</Typography>
            <FormControl 
              fullWidth 
              size='small' 
              className="search-field" 
            >
                <Select
                  value={planFor}
                  onChange={(e) => setPlanFor(e.target.value)}
                >
                  <MenuItem value="all">ទាំងអស់</MenuItem>
                  <MenuItem value="monthly">ប្រចាំខែ</MenuItem>
                  <MenuItem value="annual">ប្រចាំឆ្នាំ</MenuItem>
                </Select>
            </FormControl>
          </Grid> 

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className="header-text">ជ្រើសរើសកាលបរិច្ឆេទ</Typography>
            <LocalizationProvider 
              dateAdapter={AdapterDateFns} 
              sx={{ bgcolor: "red" }}
            >
              <DatePicker
                  className="search-field"
                  slotProps={{
                    textField: {
                      sx: {
                        "& .MuiInputBase-input": {
                          padding: "8.5px 14px",
                        },
                      },
                    },
                  }}
                  fullWidth
                  value={date ? parseISO(date) : null}
                  format={planFor === "annual" ? "yyyy" : "MM/yyyy"}
                  views={ planFor === "annual" ? ['year'] : ['year','month']}
                  onChange={(date) => setDate(date ? date.toISOString() : null)}
                  renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                  )}
              />
            </LocalizationProvider>
          </Grid>

          <Box flexGrow={1} />
          <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpenCreate}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                បង្កើត
              </Button>
            </Stack>

            {
              openCreate && 
              <InventoryPlanForm
                open={openCreate}
                handleClose={handleCloseCreate}
                setRefetch={refetch}
                dialogTitle="Create"
              />
            }
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start" width="10%">
                ល.រ
              </TableCell>
              <TableCell className="header-title" width="20%">
                ឆ្នាំសិក្សា
              </TableCell>
              <TableCell className="header-title" width="20%">
                ផែនការ
              </TableCell>
              <TableCell className="header-title" width="30%">
                កាលបរិច្ឆេទ
              </TableCell>
              <TableCell className="header-title" width="30%">
                ចំណាំ
              </TableCell>
              <TableCell className="header-title-end" width="30%"></TableCell>
            </TableHead>

            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={6} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={6} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow className="body-row"
                          key={index}
                        >
                          <TableCell className="body-cell-start">
                            {index + paginationData?.slNo}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.academicYearId?.academicYearInKhmer}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.planFor === "monthly" ? "ប្រចាំខែ" : "ប្រចាំឆ្នាំ" }
                          </TableCell>
                          <TableCell className="body-cell">
                            {moment(row?.date)?.format( row?.planFor === "monthly" ? "MM-YYYY" : "YYYY" )}
                          </TableCell>
                          <TableCell className="body-cell" >
                            {row?.remark}
                          </TableCell>
                          <TableCell className="body-cell-end" align="right">
                            <InventoryPlanAction
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
